import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { deletePriceSchemeCategory } from 'src/api/deletePriceSchemeCategory/deletePriceSchemeCategory';

type Options = Omit<UseMutationOptions<any, unknown, string, unknown>, 'mutationFn'>;

export const useDeletePriceSchemeCategory = (priceSchemeId: string, options: Options = {}) => {
  return useMutation({
    mutationFn: (categoryId: string) => deletePriceSchemeCategory(priceSchemeId, categoryId),
    ...options,
  });
};
